import { IonFooter } from "@ionic/react";
import React, { useState } from "react";
import axios from "axios";
import "../assets/css/footer.css";

const Footer = (props) => {
	const [email, setEmail] = useState("");
	const [submitting, setSubmitting] = useState(false);
	// { type: "success" | "error", text } — shown under the subscribe button.
	const [status, setStatus] = useState(null);

	const handleSubscribe = async (e) => {
		e.preventDefault();
		if (submitting) return;

		if (!email.trim()) {
			setStatus({ type: "error", text: "Please enter your email address." });
			return;
		}

		setSubmitting(true);
		setStatus(null);
		try {
			const res = await axios.post("/mail/subscribe", { email });
			setStatus({
				type: "success",
				text: res.data?.message || "You're subscribed — check your inbox.",
			});
			setEmail("");
		} catch (err) {
			setStatus({
				type: "error",
				text:
					err.response?.data?.message ||
					"Something went wrong. Please try again in a moment.",
			});
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<IonFooter>
			<footer>
				<div className="center_wrapper">
					<div>
						<a href="/">
							<img
								src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
								id="footer_logo"
							/>
						</a>
						<div className="footer_headings"></div>
						<div>About us</div>
						<div>Our Leadership</div>
						<div>Press</div>
						<div>Join Us</div>
						<div>Contact</div>
					</div>
					<div>
						<div className="footer_headings">Courses</div>
						<div>Manufacturing & Operations Management</div>
						<div>Finance</div>
						<div>Taxation and Risk Management</div>
						<div>Industrial Safety</div>
						<div>Market Sales</div>
					</div>
					<div>
						<div className="footer_headings">Quick Links</div>
						<div>Privacy Policy</div>
						<div>Discussion</div>
						<div>Terms and Conditions</div>
						<div>Customer Support</div>
						<div>FAQs</div>
					</div>
					<div>
						<div className="footer_headings">
							Subscribe to our Monthly Newsletter
						</div>
						<div>
							Lorem ipsum sed Lorem ipsum dolor sit amet, consectetuer adipisg
							elitsed
						</div>
						<form onSubmit={handleSubscribe} noValidate>
							<input
								type="email"
								id="email"
								name="email"
								autoComplete="email"
								placeholder="E-mail Address"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
							<button
								type="submit"
								className="yellow_btn"
								id="subscribe_btn"
								disabled={submitting}
							>
								{submitting ? "Subscribing..." : "Subscribe"}
							</button>
							{status && (
								<div
									className={`subscribe_status subscribe_status_${status.type}`}
									role="status"
								>
									{status.text}
								</div>
							)}
						</form>
					</div>
				</div>
			</footer>
		</IonFooter>
	);
};

export default Footer;
